/*
 * @Author: LXG
 * @Date: 2021-05-15
 * @Editors: LXG
 * @LastEditTime: 2021-05-15
 * @Description: 通用工具类
 */
function checkDataType(data) {
    let type = Object.prototype.toString.call(data);
    type = type.split(' ')[1];
    type = type.substring(0, type.length - 1);

    return type
}

export {
    checkDataType,
}